module.exports = __webpack_public_path__ + "img/italy-diabetes-mellitus-male.3a9ab3d0.png";